import { useEffect, useState } from 'react';
import {
  PHONE_COUNTRY_CODE,
  sanitizeNationalPhoneInput,
  toInternationalPhoneNumber,
  toNationalPhoneNumber,
} from '../utils/phone';

type PhoneInputProps = {
  id: string;
  name?: string;
  value?: string;
  defaultValue?: string;
  onChange?: (international: string) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
};

export default function PhoneInput({
  id,
  name,
  value,
  defaultValue,
  onChange,
  disabled = false,
  required = false,
  placeholder = '5xx xxx xx xx',
}: PhoneInputProps) {
  const isControlled = value !== undefined;
  const [national, setNational] = useState(() =>
    toNationalPhoneNumber(defaultValue ?? value ?? ''),
  );

  useEffect(() => {
    if (isControlled) {
      setNational(toNationalPhoneNumber(value));
    }
  }, [isControlled, value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextNational = sanitizeNationalPhoneInput(event.target.value);
    if (!isControlled) {
      setNational(nextNational);
    }
    onChange?.(toInternationalPhoneNumber(nextNational));
  };

  const displayValue = isControlled ? toNationalPhoneNumber(value ?? '') : national;
  const international = toInternationalPhoneNumber(displayValue);

  return (
    <div className="phone-input">
      <span className="phone-input-prefix" aria-hidden="true">
        {PHONE_COUNTRY_CODE}
      </span>
      <input
        id={id}
        className="phone-input-field"
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        value={displayValue}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        maxLength={10}
      />
      {name && <input type="hidden" name={name} value={international} />}
    </div>
  );
}
